import React from 'react';
import { Reveal } from './Reveal';
const withoutItems = ['😓 Répéter les mêmes schémas sans savoir pourquoi', '🔁 Des ressources dispersées qui manquent de structure', '💭 Manquer de clarté sur certains schémas répétitifs', '😰 Transmettre les mêmes blessures à vos enfants', '🌙 Vivre toute sa vie dans l’histoire de quelqu’un d’autre'];
const withItems = ['📖 Ouvrir votre carte de constellation', '🎯 Identifier le schéma racine — pas juste le symptôme', '💪 Appliquer la phrase de guérison. Ressentir le changement.', '♾️ Identifier le cycle et commencer à créer de nouveaux repères', '📅 Écrire l’héritage que vous seul pouvez laisser'];
function Panel({
  title,
  label,
  items,
  positive
}: {
  title: string;
  label: string;
  items: string[];
  positive?: boolean;
}) {
  return <div className={`p-7 sm:p-10 ${positive ? 'bg-surface' : 'bg-mist'}`} data-id="element-31" data-mp="9kxkisetvght">
      <p className={`text-xs font-bold uppercase tracking-[0.16em] ${positive ? 'text-sage' : 'text-red-500'}`} data-id="element-32" data-mp="eiflnwmlsrf9">
        {label}
      </p>
      <h3 className="mt-4 font-serif text-3xl leading-tight text-navy" data-id="element-33" data-mp="1m2a53w7miqar">{title}</h3>
      <ul className="mt-7 divide-y divide-navy/10" data-id="element-34" data-mp="1h8xs6jcb47xu">
        {items.map(item => <li key={item} className="py-4 text-sm leading-relaxed text-slate sm:text-base" data-id="element-35" data-mp="1d7m44i92zurr">
            {item}
          </li>)}
      </ul>
    </div>;
}
export function Comparison() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-36" data-mp="24zutz3ae1ovd">
      <div className="mx-auto max-w-6xl" data-id="element-37" data-mp="20xzw68ro1tmc">
        <Reveal className="mx-auto max-w-3xl text-center" data-id="element-38" data-mp="20z19kjw5ms78">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-39" data-mp="1vywp6is4ldbq">
            ⚖️ La différence qu’un <span className="text-sage" data-id="element-40" data-mp="1qzsipzwl5tp3">vrai système</span> fait
          </h2>
          <p className="mt-5 text-slate" data-id="element-41" data-mp="1r1wjwa33oelo">
            Vous n’achetez pas des fichiers. Vous achetez un système complet de guérison opérationnel.
          </p>
        </Reveal>
        <Reveal delay={0.08} data-id="element-42" data-mp="fjvjniv19te5">
          <div className="mt-10 overflow-hidden rounded-2xl border border-navy/10 shadow-elevated md:grid md:grid-cols-2" data-id="element-43" data-mp="fmpymuva2m06">
            <Panel label="❌ Sans le système" title="Sans le Système des Constellations Familiales™" items={withoutItems} data-id="element-44" data-mp="m0n96zj8es1x" />
            <Panel positive label="✅ Avec le système" title="Avec le Système des Constellations Familiales™" items={withItems} data-id="element-45" data-mp="83grl8a8uzea" />
          </div>
        </Reveal>
      </div>
    </section>;
}